import * as CryptoJS from 'crypto-js';

let cv = '';

function generateRandomString(length: number): string {
  let text = '';
  const codeVerifier = localStorage.getItem('code_verifier');
  if (codeVerifier !== null && codeVerifier !== undefined && codeVerifier !== '') {
    cv = codeVerifier;
    return codeVerifier;
  } else {
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
    for (let i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    cv = text;
    localStorage.setItem('code_verifier', cv);
    return text;
  }
}

function generateCodeChallenge(codeVerifier: string): string {
  const codeChallenge = base64URL(CryptoJS.SHA256(codeVerifier));
  return codeChallenge + '&code_challenge_method=S256';
}

function base64URL(string: CryptoJS.lib.WordArray): string {
  return string.toString(CryptoJS.enc.Base64).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
export const environment = {
  production: true,
  envName: 'prod',
  hostname:'ebom.toyota.com',
  authBucket:'prod.access-auth',
  searchGridUrl:'https://searchgrids.ebom.toyota.com/',
  redirectUrl: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/authorize?client_id=5bb42f60-9d2e-4747-b391-5395c49c9c24&response_type=code&redirect_uri=https://ebom.toyota.com&response_mode=query&scope=openid&state=23343&code_challenge=',
  apiUrl: "https://api.ebom.toyota.com/ebom",
  MastergridapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  MastersearchdropdownapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown1apiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown2apiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_1',
  Mastersearchdropdown3apiUrlrest1: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  Mastersearchdropdown3apiUrlrest2: 'https://api.ebom.toyota.com/ebom_common_rest_3',
  BussinessgridapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_3',
  QualandExcpgridapi1Url: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  BusinesssearchdropdownapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_3',
  Business_Qe_dropdownapiURL: 'https://api.ebom.toyota.com/ebom_common_rest_1',
  Master_ActionapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_1',
  Master_EditapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_3',
  Master_ActionInsertApiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_1',
  // BusinessManAdjstapiUrl: 'https://6gr5m8y0u3.execute-api.us-east-1.amazonaws.com/dev/api',
  BussinessppsvapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionRestapiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  BusinessActionS2apiUrl: 'https://api.ebom.toyota.com/ebom_common_rest_2',
  Uploadrest: ' https://api.ebom.toyota.com/ebom_common_rest_3',
  NewURL : 'https://api.ebom.toyota.com/prod_master_insert',
  CommonS6RestUrl: 'https://api.ebom.toyota.com/prod_common_s6_rest',
  commonS9RestUrl: 'https://6r2ghqvn2k.execute-api.us-west-2.amazonaws.com/dev', // TODO: update to prod URL when available
  region: 'us-east-1',
  workdayId: "EmployeeID",
  uploadBucketName: 'prod.ebom.fileupload',
  downloadBucketName: 'prod.ebom.monthlyreport',
  logoutUrl: 'https://login.microsoftonline.com/common/oauth2/logout',
  rmvUserDetailsUrl:'https://th4huac7nb.execute-api.us-west-2.amazonaws.com/prod/api/',
  tokenURL: 'https://login.microsoftonline.com/8c642d1d-d709-47b0-ab10-080af10798fb/oauth2/v2.0/token',
  grantType: 'authorization_code',
  clientId: '5bb42f60-9d2e-4747-b391-5395c49c9c24',
  redirectURI: 'https://ebom.toyota.com',
  codeVerifier: generateRandomString(128),
  codeChallenge: generateCodeChallenge(cv)
};